import { CsrfToken } from '@brainfocus/web/components/csrfToken/csfdToken';
import { TextInput } from '@brainfocus/web/components/text_input/text_input';

export function ResetPasswordNew() {
    return (
        <div class='bf-ui-content'><div class='container'>
            <div class='flex-column align-items-center'>
                <h1>New password</h1>
                <p class='mb-4'>Please fill in your new password</p>
                <form method='POST' class='d-contents'>
                    <TextInput output='string' type='password' name='password' label='Password' />
                    <TextInput output='string' type='password' name='password_confirmation' label='Confirm your password' />
                    <CsrfToken />
                    <button type='submit' class='bf-action'>Submit</button>
                </form>
            </div>
        </div></div>
    );
}
